export enum NumberOfDecimalTypes{
    Default = 'default',
    System = 'system'
}